import React, { useEffect, useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";

const SessionList = () => {
  const [responce, loading, error, callAPI,statusCode] = useApiCallHooks();
    const [isCall, setIsCall] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");

  useEffect(() => {
    callAPI("get", "student/get-student-session-list");
  }, []);

  const data = responce?.data || [];

  const filteredSessions = data.filter((session) => {
    return (
      session.session?.title?.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (typeFilter === "" || session.type === typeFilter) &&
      (statusFilter === "" || session.status === statusFilter)
    );
  });

  const handleJoinClick = (student_session_id, url) => {
    // Send the POST update
    callAPI("post", "student/update-student-session-status", {
      student_session_id,
      is_join: 1,
    });
     if (statusCode === 202 && !isCall) {
        setIsCall(true);
        callAPI("get", "student/get-student-assign-task");
        // setTasks([]);
    }


    // Open the link in new tab
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const sessionStats = {
    total: data.length,
    upcoming: data.filter((s) => s.status === "Upcoming").length,
    completed: data.filter((s) => s.status === "Completed").length,
    today: data.filter((s) => {
      const today = new Date().toISOString().split("T")[0];
      return s.session?.program?.start_date === today;
    }).length,
  };
  

  return (
    <AdminAppBody
    loading={loading}
      content={
        <div className="container py-4">
          <h4 className="fw-bold mb-4">📚 Session List</h4>

          {/* Stats */}
          <div className="row g-3 mb-4">
            {Object.entries(sessionStats).map(([label, value]) => (
              <div key={label} className="col-md-3">
                <div className="border rounded p-3 text-center">
                  <div className="fs-3">
                    {label === "total"
                      ? "📊"
                      : label === "upcoming"
                      ? "📅"
                      : label === "completed"
                      ? "✅"
                      : "📆"}
                  </div>
                  <div className="fw-semibold text-capitalize">
                    {label.replace("total", "Total Sessions")}
                  </div>
                  <div>{value}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Filters */}
          <div className="bg-white rounded shadow-sm p-3 mb-4">
            <div className="row g-2 align-items-center">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="🔍 Search by title"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-md-3 d-flex align-items-center">
                <span className="me-2">🧩 Filter:</span>
                <select
                  className="form-select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">Select Status</option>
                  <option value="Completed">Completed</option>
                  <option value="Upcoming">Upcoming</option>
                </select>
              </div>
              <div className="col-md-3">
                <select
                  className="form-select"
                  value={typeFilter}
                  onChange={(e) => setTypeFilter(e.target.value)}
                >
                  <option value="">Select Type</option>
                  <option value="Individual">Individual</option>
                  <option value="Group">Group</option>
                </select>
              </div>
            </div>
          </div>

          {/* Session Cards */}
          <div className="row g-3">
            {filteredSessions.map((item) => (
              <div key={item.id} className="col-md-4">
                <div className="bg-white rounded shadow-sm p-3 h-100">
                  <h5 className="fw-bold mb-2">📘 {item.session?.title}</h5>
                  <div className="mb-1">
                    📅 {item.session?.start_date} &nbsp;&nbsp; 🕒{" "}
                    {item.session?.time}
                  </div>
                  <div className="mb-1">👤 {item.session?.topic?.name}</div>
                  <div className="mb-2 fw-semibold">
                    👨‍🏫 {item.session?.mentor?.first_name}{" "}
                    {item.session?.mentor?.last_name}
                  </div>
                  <button
                    className="btn btn-outline-primary"
                    onClick={() =>
                      handleJoinClick(item.id, item.session?.url)
                    }
                  >
                    🔗 Join Link
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      }
    />
  );
};

export default SessionList;
